import addresses from "@/store/modules/addresses";
import affiliates from "@/store/modules/affiliates";
import alerts from "@/store/modules/alerts";
import allocations from "@/store/modules/allocations";
import allSites from "@/store/modules/allSites";
import allStencils from "@/store/modules/allStencils";
import analytics from "@/store/modules/analytics";
import announcements from "@/store/modules/announcements";
import appPackages from "@/store/modules/appPackages";
import apps from "@/store/modules/apps";
import auth from "@/store/modules/auth";
import backups from "@/store/modules/sites/backups";
import cartstack from "@/store/modules/cartstack";
import cdnControlPanel from "@/store/modules/cdnControlPanel";
import certificates from "@/store/modules/sites/certificates";
import chart from "@/store/modules/chart";
import checkout from "@/store/modules/checkout";
import cloudServerPackages from "@/store/modules/cloudServerPackages";
import cloudServers from "@/store/modules/services/cloudServers";
import colocations from "@/store/modules/services/colocations";
import company from "@/store/modules/company";
import containerPassword from "@/store/modules/containerPassword";
import containers from "@/store/modules/containers";
import creditcards from "@/store/modules/creditcards";
import credits from "@/store/modules/credits";
import databases from "@/store/modules/databases";
import databaseUsers from "@/store/modules/databaseUsers";
import dedicatedServers from "@/store/modules/services/dedicatedServers";
import devSites from "@/store/modules/devSites";
import discounts from "@/store/modules/discounts";
import dns from "@/store/modules/sites/dns";
import dnsZoneARecords from "@/store/modules/dnsZones/aRecords";
import dnsZoneCaaRecords from "@/store/modules/dnsZones/caaRecords";
import dnsZoneCnameRecords from "@/store/modules/dnsZones/cnameRecords";
import dnsZoneMxRecords from "@/store/modules/dnsZones/mxRecords";
import dnsZoneNsRecords from "@/store/modules/dnsZones/nsRecords";
import dnsZones from "@/store/modules/dnsZones/zones";
import dnsZoneSpfRecords from "@/store/modules/dnsZones/spfRecords";
import dnsZoneSrvRecords from "@/store/modules/dnsZones/srvRecords";
import dnsZoneTxtRecords from "@/store/modules/dnsZones/txtRecords";
import domains from "@/store/modules/services/domains";
import emailAliases from "@/store/modules/emailAliases";
import emailBoxes from "@/store/modules/emailBoxes";
import ftp from "@/store/modules/sites/ftp";
import httpPassword from "@/store/modules/sites/httpPassword";
import invoices from "@/store/modules/invoices";
import letsencrypt from "@/store/modules/sites/letsencrypt";
import locations from "@/store/modules/locations";
import logs from "@/store/modules/sites/logs";
import modals from "@/store/modules/modals";
import nav from "@/store/modules/nav";
import newRelic from "@/store/modules/newRelic";
import orders from "@/store/modules/orders";
import os from "@/store/modules/os";
import others from "@/store/modules/services/others";
import overlay from "@/store/modules/overlay";
import packages from "@/store/modules/packages";
import partnerCredits from "@/store/modules/partnerCredits";
import partnerLinks from "@/store/modules/partnerLinks";
import partnerReferrals from "@/store/modules/partnerReferrals";
import password from "@/store/modules/password";
import passwordProtection from "@/store/modules/sites/passwordProtection";
import payments from "@/store/modules/payments";
import php from "@/store/modules/php";
import plans from "@/store/modules/plans";
import pointerDomains from "@/store/modules/sites/pointerDomains";
import rdnsRecords from "@/store/modules/rdnsRecords";
import remoteUser from "@/store/modules/sites/remoteUser";
import resellerHosts from "@/store/modules/services/resellerHosts";
import safeHarbor from "@/store/modules/safeHarbor";
import settings from "@/store/modules/settings";
import sharedHosts from "@/store/modules/sharedHosts";
import siteCron from "@/store/modules/siteCron";
import sites from "@/store/modules/sites";
import sshKeys from "@/store/modules/keys";
import sslPackages from "@/store/modules/sslPackages";
import stencils from "@/store/modules/stencils";
import tax from "@/store/modules/tax";
import team from "@/store/modules/team";
import theme from "@/store/modules/theme";
import ticketPosts from "@/store/modules/ticketPosts";
import tickets from "@/store/modules/tickets";
import toasts from "@/store/modules/toasts";
import tokens from "@/store/modules/tokens";
import visualComparison from "@/store/modules/sites/visualComparison";
import wpWoo from "@/store/modules/sites/wpWoo";

export default {
  addresses,
  affiliates,
  alerts,
  allocations,
  allSites,
  allStencils,
  analytics,
  announcements,
  appPackages,
  apps,
  auth,
  backups,
  cartstack,
  cdnControlPanel,
  certificates,
  chart,
  checkout,
  colocations,
  cloudServerPackages,
  cloudServers,
  company,
  containerPassword,
  containers,
  creditcards,
  credits,
  databases,
  databaseUsers,
  dedicatedServers,
  devSites,
  discounts,
  dns,
  dnsZoneARecords,
  dnsZoneCaaRecords,
  dnsZoneCnameRecords,
  dnsZoneMxRecords,
  dnsZoneNsRecords,
  dnsZones,
  dnsZoneSpfRecords,
  dnsZoneSrvRecords,
  dnsZoneTxtRecords,
  domains,
  emailAliases,
  emailBoxes,
  ftp,
  httpPassword,
  invoices,
  letsencrypt,
  locations,
  logs,
  modals,
  nav,
  newRelic,
  orders,
  os,
  others,
  overlay,
  packages,
  partnerCredits,
  partnerLinks,
  partnerReferrals,
  password,
  passwordProtection,
  payments,
  php,
  plans,
  pointerDomains,
  rdnsRecords,
  remoteUser,
  resellerHosts,
  safeHarbor,
  settings,
  sharedHosts,
  siteCron,
  sites,
  sshKeys,
  sslPackages,
  stencils,
  tax,
  team,
  theme,
  ticketPosts,
  tickets,
  toasts,
  tokens,
  visualComparison,
  wpWoo,
};
